<div class="mui-circle-percent__wrapper">
  <svg class="mui-circle-percent__vector" height="100%" width="100%"
       role="progressbar"
       [attr.aria-labelledby]="id + '-label'"
       [attr.aria-valuenow]="percent"
  >
    <g class="mui-circle-percent__rotate" #circleGroup>
      <circle
        class="mui-circle-percent__circle mui-circle-percent__circle-background"
        cx="50%"
        cy="50%"
        r="30%"
        stroke="#000000"
        stroke-width="35px"
        fill="none"/>
    </g>
  </svg>
  <span [id]="id + '-label'" class="mui-circle-percent__text">{{ percent }}%</span>
</div>
